import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { registerGuard } from './router-guard'
import IdentityCallback from '@/views/authentication/IdentityCallback.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      meta: { title: 'Home' },
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/HomeView.vue'),
        },
        {
          path: '/timers',
          name: 'timers',
          component: () => import('@/views/TimersView.vue'),
          meta: { title: 'Timers' },
        },
        {
          path: '/ad-timings',
          name: 'ad-timings',
          component: () => import('@/views/AdTimingsView.vue'),
          meta: { title: 'Timings Configuration' },
        },
        {
          path: '/ad-eta-thresholds',
          name: 'ad-eta-thresholds',
          component: () => import('@/views/AdEtaThresholdsView.vue'),
          meta: { title: 'ETA Thresholds Configuration' },
        },
        {
          path: '/best-eta-rejection-reasons',
          name: 'best-eta-rejection-reasons',
          component: () => import('@/views/BestEtaRejectionReasonsView.vue'),
          meta: { title: 'Best ETA Rejection Reasons' },
        },
      ],
    },
    {
      path: '/identity/callback',
      component: AuthLayout,
      children: [
        {
          path: '',
          name: 'identityCallback',
          component: IdentityCallback,
        },
      ],
    },
    {
      path: '/signin/error',
      name: 'signinError',
      component: () => import('@/views/authentication/SigninError.vue'),
      meta: {
        title: 'Signin Error',
        allowAnonymous: true,
      },
    },
  ],
})

registerGuard(router)

export function useTitle(title?: string) {
  document.title = [title, `${import.meta.env.VITE_APP_TITLE}`]
    .filter((t) => !!t)
    .join(' | ')
}

router.afterEach((to) => {
  useTitle(to.meta.title as string)
})

export default router
